import { render } from "./ProductAssignmentView.vue?vue&type=template&id=691c3bc0&scoped=true"
import script from "./ProductAssignmentView.vue?vue&type=script&lang=js"
export * from "./ProductAssignmentView.vue?vue&type=script&lang=js"

import "./ProductAssignmentView.vue?vue&type=style&index=0&id=691c3bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691c3bc0"]])

export default __exports__